<template>
  <div style="padding-bottom: 40px">
    <div class="homeBox" style="background: #fff">
      <ul class="home">
        <li v-for="(item,index) in images" :key="index" @click="jump(index)">
          <img src='/imgs/xueyezixun/consultant/student/new/home/finished.png' alt="" :style="{display:finish[index]==1?'block':'none'}"/>
          <div class="circle">
            <img :src="item.src" alt="">
          </div>
          <p>{{item.title}}</p>
        </li>
      </ul>
      <ul class="bottom" :style="{display:status==5?'none':'',filter:finish[0]==2?'grayscale(100%)':''}">
          <div :class="{button:true,hover:finish[0]==1}" @click="cancelJianDang" >取消建档</div>
          <div :class="{button:true,hover:finish[0]==1}" @click="save">保存建档</div>
      </ul>
      <div :style="{textAlign:'center',display:cancelBool?'':'none',filter:finish[0]==2?'grayscale':''}" class='cancelButton newStudentcancelButton'>
        <el-input type="textarea"   placeholder='请说明理由' v-model="cancelContent" class="textarea" maxlength="200"
                  show-word-limit>
        </el-input>
        <div class="button hover" style="margin-top: 30px" @click="cancel">提交审批</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
// import {MessageBox} from "element-ui"
// Vue.use(MessageBox);
// Vue.prototype.$msgbox = MessageBox
export default {
  data(){
    return{
      images:[
        {link:'',src:'/imgs/xueyezixun/consultant/student/new/home/1.png',title:'普查信息'},
        // {link:'',src:'/imgs/xueyezixun/consultant/student/new/home/2.png',title:'家长问卷'},
        // {link:'',src:'/imgs/xueyezixun/consultant/student/new/home/3.png',title:'测评报告'},
        // {link:'',src:'/imgs/xueyezixun/consultant/student/new/home/4.png',title:'首次访谈'}
      ],
      finish:[2],
      studentId:this.$route.query.id,
      cancelBool:false,
      cancelContent:'',
      status:1,
      visible:false,
      visible2:false,
      state:1,
      finish_state:''
      // cancelBool:true,
    }
  },
  
  methods:{
    
    jump(key){
      let finish=this.finish
      if(key==0){
        this.$router.push({path:'/consultant/newstudent/main/studentinformation',query:this.$route.query})
      }
      // if(key==1){
      //   this.$router.push({path:'/consultant/newstudent/main/parentinformation',query:this.$route.query})
      // }
      // if(key==2){
      //   if(finish[key]==1){
      //     this.$router.push({path:'/consultant/newstudent/main/evaluationReport',query:this.$route.query})
      //   }else{
      //     this.$message.error('暂无测评报告')
      //   }
      // }
      // if(key==2){
      //   // if(finish[key-1]==1){
      //    this.$router.push({path:'/consultant/newstudent/main/firstInterviewPartA',query:{...this.$route.query,show:(this.finish_state==1?'已完成':'未完成')}})


        
         
      // }
    },
    
    getDetail(){
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.new.getDetail,{
        id:this.$route.query.id
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          let {studentCensusQuestion,parentCensusQuestion,firstInterview,fileStatus} = res.data.data
          // this.finish=[studentCensusQuestion,parentCensusQuestion,evaluationReport,firstInterview];
          this.finish=[studentCensusQuestion];
          this.status=fileStatus
          this.finish_state = firstInterview

        }else{
          this.$message({
            message: res.data.msg,
            type: 'error'
          });
        }
      })
    },
    cancelJianDang(){
      if(this.finish[0]==1){
        this.cancelBool=!this.cancelBool
      }
    },
    cancel(){
      if(!this.cancelContent){
        this.$message.error('请说明理由')
        return;
      }
      this.$alert('取消建档审核中' ,{
        showConfirmButton:false,
        showClose:false
      });
      setTimeout(function (){
        $('.el-message-box__wrapper').remove()
        $('.v-modal').remove()
      },3000)
      this.$ajax.post(this.G_acapi + this.ports.consultant.student.new.cancelArchives,{
        studentId:this.$route.query.studentId,
        content:this.cancelContent
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          setTimeout(function (){
            $('.el-message-box__wrapper').remove()
            $('.v-modal').remove()
          },3000)
          this.status=5;
          this.cancelBool=false
        }else{
        }
      })
    },
    save(){
      // if(this.finish[0]!==1){
      //   // console.log('不等于')

      //   return false
      // }
      let _this = this

      this.$ajax.post(this.G_acapi + this.ports.consultant.student.new.saveArchives,{
        studentId:this.$route.query.studentId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==2000){
          const h = this.$createElement;
          console.log(h)
          this.$msgbox({
            message: h('span',null,[
              '建档成功,请前往', h('a',{style:'color:#3d90f6;text-decoration:underline',on:{
                  click:()=>{
                    // $('.el-message-box__wrapper').hide()
                    // $('.v-modal').hide()
                    // $('.el-popup-parent--hidden').removeClass('el-popup-parent--hidden')
                    
                    _this.$router.push('/consultant/minestudent')
                  }
                  
                }},'我的学生'),'中查看'
            ]),          
            showConfirmButton:true,
            showClose:true,  
          });
          // const h = this.$createElement;
          // this.$msgbox({
          //   title: '消息',
          //   message: h('span', null, [
          //     h('span', null, '建档成功，请前往 '),
          //     h('a', { style: 'color:#3d90f6;text-decoration:underline'}, 'VNode')
          //   ]),
          //   showCancelButton: true,
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          
          // })         
        }else{
          this.$message({
            message: res.data.msg,
            type: 'error'
          });

        }
      })
    },
    
  },
  mounted() {
    this.getDetail();
    
    
  },
}
</script>

<style scoped lang="less">
  *{
    margin: 0;
    padding: 0;
  }
  .main{
    width: 1200px;
    margin: 0 auto;
    .tabs{
      width: 280px;
      margin: 34px auto;
      display: flex;
      justify-content: space-between;
      li{
        width: 110px;
        height: 32px;
        border-radius: 15px;
        font-size: 18px;
        text-align: center;
        line-height: 32px;
        color: #3d90f6;
        cursor: pointer;
      }
      .active{
        background: linear-gradient(305deg, #3d90f6 0%, #2CB2FF 100%, #5533FF 100%);
        box-shadow: 0px 6px 6px 0px rgba(0, 149, 235, 0.4);
        border-radius: 15px;
        color:#fff;
      }
    }
    .show{
      color:#1EA1EE;
      cursor: pointer;
      -webkit-user-select:none;
      -moz-user-select:none;
      -ms-user-select:none;
      user-select:none;
      &:hover {
        font-weight: bold;
      }
    }
    .unShow {
      color: #666;
      cursor: not-allowed;
    }
  }
  .new{
    width: 940px;
    margin: 0 auto;
    .navInputs{
      &>span{
        margin-right: 8px;
      }
      input{
        margin-right: 12px;
      }
    }
  }
  .homeBox{
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 30px;
    overflow: hidden;
    .home{
      width: 960px;
      margin: 117px auto 50px;
      display: flex;
      justify-content: center;
      li{
        width: 180px;
        height: 220px;
        background: #FFFFFF;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        &>img{
          position: absolute;
          left: 0;
          top: 0;
        }
        .circle{
          width: 100px;
          height: 100px;
          background: rgba(0, 149, 235, 0.06);
          border-radius: 50%;
          margin: 40px auto 20px;
          padding-top: 30px;
          text-align: center;
        }
        p{
          font-size: 18px;
          font-weight: 500;
          color: #3d90f6;
          line-height: 25px;
          text-align: center;
        }
      }
    }
    .bottom{
      width: 330px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      li{
        width: 128px;
        height: 32px;
        line-height: 32px;
        background: #C8C6C6;
        box-shadow: 0px 4px 6px 0px rgba(196, 196, 196, 0.4);
        border-radius: 15px;
        text-align: center;
        font-size: 18px;
        color: #fff;
        cursor: pointer;
      }
      .newActive{
        color:#fff;
        background:#0094EA;
      }
    }
    .cancelButton{
      width:960px;
      margin: 60px auto 20px;
    }

  }
  .button{
    border-radius: 16px;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    cursor: pointer;
    background: #ECF8FE;
    color: #1EA2EE;
    border: 1px solid #76C6F4;
    display: inline-block;
    padding: 0 20px;
  }
  .hover{
    cursor: pointer;
    &:hover{
      background: #099BEF !important;
      color: #fff !important;
    }
  }
  .bg{
    background: url("/imgs/xueyezixun/consultant/student/bg.png") center  center ;
    min-height: 600px;
    padding-top: 20px;
  }
</style>
<style lang="less">
.newStudentcancelButton{
  textarea{
    height: 160px;
  }
}
.el-message-box__message{
  span{
    font-size: 16px;
    position: relative;
    top:8px;
  }
  p{
    font-size: 16px;
  }
}
</style>